import { useMemo } from "react";
export default function useCompare(obj1, obj2) {
  return useMemo(
    () => JSON.stringify(obj1) === JSON.stringify(obj2),
    [obj1, obj2]
  );
}
